<template>
  <div>
    <b-modal id="modalEditNetFlowProvidersSetting" ref="modalEditNetFlowProvidersSetting" :title="$t('NetFlow providers')" hide-footer>
      <div  v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.provider_id != 0" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.provider_id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Traffic collector')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.collector_id" :options="trafficCollectors"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('IP')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.ip_address"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Comments')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.comments"/>
        </b-form-group>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditNetFlowProvidersSetting.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  methods: {
    validationIP () {
      let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
      if (this.editItem.ip_address.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    },
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (this.editItem.ip_address) {
        if (!this.validationIP()) {
          return
        }
      } else {
        this.editItem.ip_address = '0.0.0.0'
      }

      let response = this.editItem.provider_id !== 0
        ? this.$store.dispatch('Settings/UPDATE_NETFLOW_PROVIDERS', this.editItem)
        : this.$store.dispatch('Settings/CREATE_NETFLOW_PROVIDERS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_NETFLOW_PROVIDERS')
          this.$refs.modalEditNetFlowProvidersSetting.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  computed: {
    trafficCollectors () {
      let res = []
      for (let el of this.$store.getters['Settings/TRAFFIC_COLLECTORS']) {
        let newEl = {}
        newEl.value = el.collector_id
        newEl.text = el.name
        res.push(newEl)
      }
      res.push({value: 0, text: 'System collector (default)'})
      return res
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_TRAFFIC_COLLECTORS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/inventory/netFlowProviders/editModal.vue